import { format } from "date-fns";
export function formatDateISO(d) {
    return typeof d === "string" ? d : d.toISOString();
}
export function formatYmd(d) {
    return format(d, "yyyy-MM-dd");
}
/** Zero-padded HH:mm from a Date. */
export function formatHm(d) {
    return format(d, "HH:mm");
}
/** "HH:mm" string → minutes since midnight, or null if malformed. */
export function hmToMinutes(hm) {
    const m = /^(\d{2}):(\d{2})$/.exec(hm);
    if (!m)
        return null;
    const h = Number(m[1]);
    const mm = Number(m[2]);
    if (h < 0 || h > 23 || mm < 0 || mm > 59)
        return null;
    return h * 60 + mm;
}
/**
 * Time of day in Malaysia time, the one wording admin and POS both use: zh "上午 02:01" / "下午 08:49",
 * en "02:01 AM", ms "02:01 PG" / "08:49 PTG" (never 凌晨/早上/中午 in one app and 上午 in the other).
 */
export function formatClock(d, lang = "zh", seconds = false) {
    const parts = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23", timeZone: "Asia/Kuala_Lumpur" }).formatToParts(new Date(d));
    const g = (t) => parts.find((p) => p.type === t)?.value ?? "00";
    const h24 = Number(g("hour"));
    const hm = `${String(h24 % 12 || 12).padStart(2, "0")}:${g("minute")}${seconds ? `:${g("second")}` : ""}`;
    const am = h24 < 12;
    if (lang.startsWith("zh"))
        return `${am ? "上午" : "下午"} ${hm}`;
    if (lang.startsWith("ms"))
        return `${hm} ${am ? "PG" : "PTG"}`;
    return `${hm} ${am ? "AM" : "PM"}`;
}
//# sourceMappingURL=date.js.map